export default "__VITE_ASSET__f7543eee__"